"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _reactCurrencyFlags = _interopRequireDefault(require("react-currency-flags"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _ImageIcon = _interopRequireDefault(require("../ImageIcon/ImageIcon"));

var ReactSelect = function ReactSelect(_ref) {
  var options = _ref.options,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      currency = _ref.currency,
      value = _ref.value,
      isLoading = _ref.isLoading;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
    styles: (0, _extends2["default"])({}, styles, {
      container: function container(baseStyles) {
        return (0, _extends2["default"])({}, baseStyles, {
          width: "100%",
          marginBottom: "20px"
        });
      },
      control: function control(baseStyles) {
        return (0, _extends2["default"])({}, baseStyles, {
          border: "1px solid rgb(99, 152, 196)",
          borderRadius: "10px",
          height: "46px",
          width: "100%"
        });
      }
    }),
    options: options,
    setValue: value,
    defaultValue: defaultValue,
    onChange: onChange,
    isLoading: isLoading,
    getOptionLabel: function getOptionLabel(e) {
      return /*#__PURE__*/_react["default"].createElement(_Flex["default"], null, (e == null ? void 0 : e.icon) && /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
        src: e == null ? void 0 : e.icon,
        width: "20px",
        pl: "10px"
      }), currency && defaultValue && /*#__PURE__*/_react["default"].createElement(_reactCurrencyFlags["default"], {
        currency: e == null ? void 0 : e.value,
        size: "lg"
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        pl: "14px",
        width: "fit-content"
      }, e.label));
    }
  });
};

var _default = ReactSelect;
exports["default"] = _default;